// src/pages/Customers.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const initialCustomers = [
{
    id: 101,
    name: "Tim Cook",
    car: "Audi A4",
    stayed: "2h 15m",
    parkedBy: "Jerry Jack",
    retrievedBy: "Jerry Jack",
    paid: "$10",
    status: "previous", // or "active"
},
{
    id: 102,
    name: "Grace Hopper",
    car: "Mercedes-Benz C200",
    stayed: "1h 30m",
    parkedBy: "Zara Lanes",
    retrievedBy: "Zara Lanes",
    paid: "$8",
    status: "previous",
},
{
    id: 103,
    name: "Alan Turing",
    car: "Toyota Corolla",
    stayed: "3h 10m",
    parkedBy: "Jerry Jack",
    retrievedBy: "Anna Brave",
    paid: "$12",
    status: "active",
},
{
    id: 104,
    name: "Ada Lovelace",
    car: "BMW X5",
    stayed: "45m",
    parkedBy: "Anna Brave",
    retrievedBy: null,
    paid: "$0",
    status: "active",
},
{
    id: 105,
    name: "Elon Musk",
    car: "Tesla Model S",
    stayed: "4h 30m",
    parkedBy: "Jerry Jack",
    retrievedBy: "Anna Brave",
    paid: "$20",
    status: "previous",
},
{
    id: 106,
    name: "Marie Curie",
    car: "Volvo XC90",
    stayed: "5h 10m",
    parkedBy: "Zara Lanes",
    retrievedBy: "Zara Lanes",
    paid: "$15",
    status: "previous",
},
{
    id: 107,
    name: "Nikola Tesla",
    car: "Jaguar I-PACE",
    stayed: "2h 45m",
    parkedBy: "Anna Brave",
    retrievedBy: "Jerry Jack",
    paid: "$14",
    status: "active",
},
{
    id: 108,
    name: "Steve Jobs",
    car: "Porsche 911",
    stayed: "1h 20m",
    parkedBy: "Jerry Jack",
    retrievedBy: "Anna Brave",
    paid: "$9",
    status: "previous",
},
{
    id: 109,
    name: "Albert Einstein",
    car: "Volkswagen Passat",
    stayed: "3h 5m",
    parkedBy: "Zara Lanes",
    retrievedBy: "Zara Lanes",
    paid: "$11",
    status: "active",
},
{
    id: 110,
    name: "Rosalind Franklin",
    car: "Honda Civic",
    stayed: "2h 10m",
    parkedBy: "Anna Brave",
    retrievedBy: "Jerry Jack",
    paid: "$10",
    status: "previous",
},
{
    id: 111,
    name: "Isaac Newton",
    car: "Ford Mustang",
    stayed: "3h 50m",
    parkedBy: "Jerry Jack",
    retrievedBy: "Anna Brave",
    paid: "$18",
    status: "active",
},
{
    id: 112,
    name: "Carl Sagan",
    car: "Chevrolet Bolt",
    stayed: "4h 5m",
    parkedBy: "Zara Lanes",
    retrievedBy: "Zara Lanes",
    paid: "$16",
    status: "previous",
},
{
    id: 113,
    name: "Katherine Johnson",
    car: "Mazda CX-5",
    stayed: "3h 40m",
    parkedBy: "Anna Brave",
    retrievedBy: "Jerry Jack",
    paid: "$13",
    status: "previous",
},
{
    id: 114,
    name: "Leonardo da Vinci",
    car: "Tesla Cybertruck",
    stayed: "6h 15m",
    parkedBy: "Jerry Jack",
    retrievedBy: "Zara Lanes",
    paid: "$22",
    status: "active",
},
{
    id: 115,
    name: "Stephen Hawking",
    car: "BMW i3",
    stayed: "5h 50m",
    parkedBy: "Anna Brave",
    retrievedBy: "Jerry Jack",
    paid: "$19",
    status: "previous",
},
];


export default function Customers() {
  const [customers] = useState(initialCustomers);

  // Navigation
  const navigate = useNavigate();

  // Filter or group by active vs. previous
  const activeCount = customers.filter(c => c.status === "active").length;
  const previousCount = customers.filter(c => c.status === "previous").length;

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ marginBottom: "20px", color: "#ba00ba" }}>Customers</h2>

      {/* Summary Counters */}
      <div style={{
        display: "flex",
        gap: "20px",
        marginBottom: "20px",
        background: "#fff",
        borderRadius: "8px",
        padding: "15px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        fontSize: "1.4em",
        alignItems: "center"
      }}>
        <div><strong>Active Customers:</strong> {activeCount}</div>
        <div><strong>Previous Customers:</strong> {previousCount}</div>
      </div>

      {/* Customers Table */}
      <div style={{
        background: "#fff",
        borderRadius: "8px",
        padding: "20px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
      }}>
        <h3 style={{ marginBottom: "15px" }}>All Customers</h3>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid #eee" }}>
              <th style={{ textAlign: "left", padding: "8px" }}>Name</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Car</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Stayed</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Parked By</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Retrieved By</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Paid</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Status</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {customers.map(c => (
              <tr key={c.id} style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: "8px" }}>{c.name}</td>
                <td style={{ padding: "8px" }}>{c.car}</td>
                <td style={{ padding: "8px" }}>{c.stayed}</td>
                <td style={{ padding: "8px" }}>{c.parkedBy}</td>
                <td style={{ padding: "8px" }}>{c.retrievedBy || "-"}</td>
                <td style={{ padding: "8px" }}>{c.paid}</td>
                <td style={{ padding: "8px" }}>{c.status}</td>
                <td style={{ padding: "8px" }}>
                  <button
                    onClick={() => navigate(`/customer/${c.id}`)}
                    style={{
                      background: "#ba00ba",
                      color: "#fff",
                      border: "none",
                      borderRadius: "5px",
                      padding: "6px 12px",
                      cursor: "pointer"
                    }}
                  >
                    Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
